/** Utah's words for inspectionform.ts: the form note. */
export const INSPECTIONFORM_UT = {
  /** Which inspection forms the county health departments use (Utah: each county uses its own form, whose text we don't have). */
  countyFormsNote: "Utah counties use their own forms; we don't have their text yet.",
} as const;
